export const CUSTOM_FIELDS_TYPES = Object.freeze({
    SIMPLE_TEXT: 'simple-text',
    RICH_TEXT: 'rich-text',
    NUMERIC: 'numeric',
    AMOUNT: 'amount',
    NUMERIC_WITH_UNIT: 'numeric-with-unit',
    RADIO: 'radio',
    SELECT: 'select',
    BOOLEAN: 'boolean',
    DATE: 'date',
    TIME: 'time',
    EMAIL: 'email',
    CHECKBOX: 'checkbox',
    URL: 'url',
    THIRD: 'company-individual',
    ITEM: 'item',
    CONTACT: 'contact',
    STAFF: 'staff',
});
